<div class="role-picker-row">
  <motn-pill-multiselect
    #pillMultiselect
    [items]="RoleOptions"
    [selected]="selectedRoleOptions"
    [requireAtLeastOne]="true"
    [errorMsgInline]="true"
    [openMenu$]="rolePickerOpenMenu$"
    (add)="onAddRole($event)"
    (remove)="onRemoveRole($event)"
  ></motn-pill-multiselect>

  <div
    class="plus-btn"
    (click)="triggerRolePickerMenu()"
  >
    <i class="far fa-plus"></i>
  </div>
</div>
